import React from "react";

import {
  IconBodyStyle,
  IconDelivery,
  IconPhone,
  IconRefresh,
  IconTick,
} from "@at/design-system-icons";

import { displayNumberToDialNumber } from "@at/formatter-utils";

import { LeasingBannerLayoutProps } from "./leasing-banner.types";
import { LeasingModals } from "../../../contexts/leasing/types/leasing.types";
import { LEASING_PHONE_NUMBER } from "../../../pages/leasing/leasing-product-page.constants";

export const BannerData = () => {
  let phoneNumber = "";

  phoneNumber = LEASING_PHONE_NUMBER;

  const data: LeasingBannerLayoutProps["bannerData"] = [
    {
      modal: LeasingModals.FREE_RETURNS,
      title: "Free 30-day returns",
      text: "Free 30-day returns*",
      tracking: "free-30-day-returns-open-modal",
      icon: <IconRefresh title="" size={18} />,
    },
    {
      modal: LeasingModals.ROAD_TAX,
      title: "Road tax and roadside assistance",
      text: "Road tax included",
      tracking: "road-tax-included-open-modal",
      icon: <IconBodyStyle title="" size={18} />,
    },
    {
      modal: LeasingModals.FREE_DELIVERY,
      title: "Free delivery to your door",
      text: "Free delivery to your door**",
      tracking: "free-delivery-open-modal",
      icon: <IconDelivery title="" size={18} />,
    },
    {
      modal: LeasingModals.NO_ADMIN_FEES,
      title: "No admin fees",
      text: "No admin fees",
      tracking: "no-admin-fees-open-modal",
      icon: <IconTick title="" size={18} />,
    },

    {
      link: `tel:${displayNumberToDialNumber(phoneNumber)}`,
      title: phoneNumber,
      text: phoneNumber,
      tracking: "phone-number-called",
      icon: <IconPhone title="" size={18} />,
    },
  ];

  return { data };
};
